import { defineStore } from 'pinia'
import { nextTick, ref } from 'vue'

import type { SearchableModelType } from '@/types/global'
import type { Model, Site } from '@/types/models'

export const useEventStore = defineStore('event', () => {
  const type = ref<SearchableModelType | undefined>(undefined)
  const id = ref<Model['id'] | undefined>(undefined)
  const add_manager_site_id = ref<Site['id'] | undefined>(undefined)
  const menu_loaded = ref(true)
  const updated_search_type = ref<SearchableModelType | undefined>(undefined)

  const $reset = () => {
    type.value = undefined
    id.value = undefined
    add_manager_site_id.value = undefined
    menu_loaded.value = true
    updated_search_type.value = undefined
  }

  const closeMenu = () => {
    type.value = undefined
    id.value = undefined
  }

  const openMenu = (modelType: SearchableModelType, modelId: Model['id']) => {
    type.value = modelType
    id.value = modelId
  }

  const reloadMenu = async () => {
    menu_loaded.value = false
    await nextTick(() => (menu_loaded.value = true))
  }

  const reloadSearchResults = async (updated_type: SearchableModelType) => {
    updated_search_type.value = updated_type
    await nextTick(() => (updated_search_type.value = undefined))
  }

  const setAddManagerSiteId = (site_id: Site['id']) => {
    add_manager_site_id.value = site_id
  }

  return {
    add_manager_site_id,
    id,
    menu_loaded,
    type,
    updated_search_type,
    $reset,
    closeMenu,
    openMenu,
    reloadMenu,
    reloadSearchResults,
    setAddManagerSiteId,
  }
})
